import React, { useRef, useState, useEffect } from 'react';
import Text from '../../common/Text';
import { REFERRAL_TERMS_HTML } from '../../../constants/referralTerms';

const TermsPopup = ({ terms_conditions, subscription_agreement, setTermsPopup, setIsTermsAccepted, isTermsAccepted }) => {
    const popupRef = useRef(null);
    const [isAtBottom, setIsAtBottom] = useState(false);

    const scrollToBottom = () => {
        popupRef.current.scroll({
            top: popupRef.current.scrollHeight,
            behavior: 'smooth'
        });
    };

    const handleScroll = () => {
        const { scrollTop, scrollHeight, clientHeight } = popupRef.current;
        if (scrollTop + clientHeight >= scrollHeight) {
            setIsAtBottom(true);
        } else {
            setIsAtBottom(false);
        }
    };

    useEffect(() => {
        const popupElement = popupRef.current;
        popupElement.addEventListener('scroll', handleScroll);
        return () => popupElement.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="popup lg active" ref={popupRef}>
            <div className="table_dv">
                <div className="table_cell">
                    <div className="_inner relative">
                        <div className="x_btn" onClick={() => setTermsPopup(false)}></div>
                        <div className="terms_content">
                            <h4>{terms_conditions?.page_title}</h4>
                            <Text string={terms_conditions?.policy_text} />
                            <Text string={REFERRAL_TERMS_HTML} />
                            <hr />
                            <h4>{subscription_agreement?.page_title}</h4>
                            <Text string={subscription_agreement?.policy_text} />
                            <hr />
                            <div className="small_txt text-center agree_smll">
                                <div className="txtGrp flex">
                                    {/* `htmlFor` only binds on a <label>. This was an <h6 htmlFor>,
                                        which associates nothing — clicking the sentence did not tick
                                        the box, leaving the faint 18px square as the only hit target
                                        and reading to customers as "there is no box to click". */}
                                    <div className="lblBtn flex terms_agree_check">
                                        <input
                                            type="checkbox"
                                            name="confirm"
                                            id="confirm"
                                            checked={isTermsAccepted}
                                            onChange={(e) => setIsTermsAccepted(e.target.checked)}
                                        />
                                        <label htmlFor="confirm">I agree to the Terms &amp; Conditions of the Subscription agreement</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {!isAtBottom && (
                            <button
                                className="scroll-to-bottom-btn"
                                onClick={scrollToBottom}
                            >
                                Scroll to bottom to Accept
                            </button>
                        )}
                    </div>
                </div>
            </div>

        </div>
    );
};

export default TermsPopup;
